import styled, { css } from "styled-components";
import ArrowDown from '../img/SignarrowDown16x8.svg';
import GuideImg from '../img/ContentsGraphic495x200.svg';
import ArrowUp from '../img/SignarrowTop16x8.svg';
import FaqImg from '../img/FAQ94x28.svg';
import Collapse from "@mui/material/Collapse";
import React, {useState} from "react";


const GuideWrapper = styled.div`
  margin-bottom: 32px;
`;

const GuideFrame = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 22px 30px;
  width: 100%;
  height: 80px;
  background: linear-gradient(270.83deg, #3195E0 0%, #2EC3F2 100%);
  flex: none;
  order: 0;
  flex-grow: 1;
  cursor: pointer;
  @media (max-width: 766px) {
    display: none;
  }
`;

const GuideMainText = styled.h1`
  font-family: Gongim-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 130%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  @media (max-width: 1099px) {
    font-size: 22px;
  }
`;

const GuideSubText = styled.div`
  gap: 4px;
  display: flex;
  align-items: center;
`;

const MoreText = styled.div`
  font-family: Gongim-Medium;
  font-size: 16px;
  color: #fff;
  line-height: 20.8px;
`;

const Arrow = styled.img`
  width: 16px;
  height: 8px;
  margin-left: 3px;
`;

const GuideContentFrame = styled.div`
  width: 1100px;
  height: 721px;
  //position: fixed;
  //top: 50%;
  //left: 50%;
  //transform: translate(-50%, -50%);
  //
  background-color: #fff;
  border: 3px solid transparent;
  padding: 40px;
  border-image: linear-gradient(to left, #3195E0 0%, #2EC3F2 100%);
  border-image-slice: 1;
  @media (max-width: 1099px) {
    width: 100%;
    height: 569px;
    padding: 30px 24px;
    top: 35%;
  }
`;

const GuideContent = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  text-align: left;
  justify-content: space-between;
  gap: 32px;
`;

const SubTitleText = styled.h2`
  font-size: 24px;
  font-family: 'Noto Sans KR';
  color: #3195E0;
  margin: 0;
  margin-bottom: 10px;
  margin-top: 10px;
  @media (max-width: 1099px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-family: Gongim-Medium;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: #3195E0;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
`;

const SubContentText = styled.p`
  font-family: Gongim-Medium;
  overflow-wrap: break-word;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 160%;
  align-items: center;
  color: #707070;
  flex: none;
  order: 0;
  flex-grow: 1;
  @media (max-width: 1099px) {
    font-size: 14px;
  }
`;

const BlueBoldText = styled.div`
  font-family: Gongim-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  display: flex;
  align-items: center;
  color: #3195E0;
  flex: none;
  order: 1;
  flex-grow: 0;
  cursor: pointer;
  @media(max-width: 1099px) {
    display: none;
  }
`;

const BlueBoldMobileText = styled.div`
  display: none;
  font-family: Gongim-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  align-items: center;
  color: #3195E0;
  flex: none;
  order: 1;
  flex-grow: 0;
  cursor: pointer;
  @media(max-width: 1099px) {
    display: block;
  }
`;


const ContentImg = styled.img`
  width: 495px;
  height: 200px;
  @media (max-width: 1099px) {
    display: none;
  }

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    height: auto;
    margin: 32px 0;
  }
`;

const Content1 = styled.div`
  width: 100%;
  height: auto;
`

const ContentSub = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const ContentSubTitle = styled.div`
  width: 120px;
  color: #333333;
  font-size: 20px;
  font-family: Gongim-Medium;

  @media (max-width: 1099px) {
    font-size: 16px;
    width: 84px;
  }

  @media (max-width: 768px) {
    font-family: 'Noto Sans KR';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: #333333;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
`;

const ContentSubText = styled.div`
  width: 900px;
  font-family: Gongim-Medium;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #707070;
  flex: none;
  order: 0;
  flex-grow: 1;
  @media (max-width: 1099px) {
    font-size: 1.5vw;
    width: 80%;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  font-family: Gongim-Medium;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  margin-bottom: 6px;
  color: #707070;
  @media (max-width: 1099px) {
    font-size: 1.4vw;
    margin: 0;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    margin: 6px 0;
  }
`;

const BoldText = styled.div`
  color: #333333;
  @media (max-width: 1099px) {
    font-size: 14px;
    width: 150px;
  }
  @media (max-width: 768px) {
    font-family: Gongim-Medium;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: #333333;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin-top: 16px;
  }
`;

const BrTag = styled.br`
  display: none;

  @media (max-width: 1099px) {
    display: flex;
  }
`;

const GuideMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const GuideMobileButton = styled.button`
  position: absolute;
  top: 6%;
  right: 0;
  transform: translate(-50%, -50%);
  font-family: Gongim-Medium;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  width: 65px;
  height: 30px;
  background: #349DEC;
  border-radius: 999px;
  border: 0;
  flex: none;
  order: 1;
  flex-grow: 0;
  font-size: 13px;
  color: #fff;
`;


const GuidePopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  padding: 0 20px;
`;

const PopupContent = styled.div`
  width: 100%;
  height: 90vh;
`;

const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 0 80px 0;
  background-color: #fff;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
    padding-top: 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const PopupTitle = styled.h2`
  width: 100%;
  margin: 30px 0;
  font-size: 22px;
  font-family: Gongim-Medium;
  text-align: left;
`

const PopupText = styled.div`
  width: 100%;
  height: 90%;
  overflow-y: scroll;
`;

const FAQ = styled.img`
  width: 94px;
  height: auto;
  cursor: pointer;
  @media (max-width: 768px) {
    height: auto;
    margin: 20px 0;
    margin-right: 250px;
  }
`



export default function Guide() {
    const [onPopup, setOnPopup] = useState(false);
    const [mobilePopup, setMobilePopup] = useState(false);

    return (
        <>
            <GuideWrapper>
                <GuideFrame onClick={() => {setOnPopup(!onPopup)}}>
                    <GuideMainText>공임나라 딜리버리 이용 가이드</GuideMainText>
                    <GuideSubText>
                        <MoreText>더보기</MoreText>
                        <Arrow src={ArrowDown}/>
                    </GuideSubText>
                </GuideFrame>

                {/*{ onPopup === true &&*/}
                {/*    <GuideContentFrame onMouseEnter={() => {setOnPopup(true)}} onMouseLeave={() => {setOnPopup(false)}}>*/}
                {/*        <GuideContent>*/}
                {/*            <div>*/}
                {/*                <SubTitleText>공임나라 딜리버리 서비스?</SubTitleText>*/}
                {/*                <SubContentText>*/}
                {/*                    "귀찮은 내 차 정비 이동, 꼭 내가 해야 할까?"*/}
                {/*                    공임나라가 자동차 이동 서비스를 시작합니다. 공임나라 이용시 번거롭게 내 차를 직접 가져다주고, 가져올 필요가 없습니다. 정비 입고 뿐 아니라 출고에 맞춰 예약만 하면 고객님의 자동차를 원하는 시간, 원하는 장소까지 안전하게 옮겨 드리는 편리한 서비스입니다.*/}
                {/*                </SubContentText>*/}
                {/*            </div>*/}
                {/*            <div>*/}
                {/*                <ContentImg src={GuideImg} />*/}
                {/*            </div>*/}
                {/*        </GuideContent>*/}
                {/*        <GuideContent>*/}
                {/*            <div>*/}
                {/*                <SubTitleText>공ㆍ딜 200% 활용하기</SubTitleText>*/}
                {/*                <Content1>*/}
                {/*                    <ContentSub>*/}
                {/*                        <ContentSubTitle>보내기</ContentSubTitle>*/}
                {/*                        <ContentSubText>출근시 딜리버리로 정비입고 후 퇴근시 방문하여 귀가 [ 집 or 회사 > 정비소 ] </ContentSubText>*/}
                {/*                    </ContentSub>*/}
                {/*                    <ContentSub>*/}
                {/*                        <ContentSubTitle>가져오기</ContentSubTitle>*/}
                {/*                        <ContentSubText>출근시 정비소에 직접 입고 후 [ 정비소 > 집 or 회사 ] 로 딜리버리</ContentSubText>*/}
                {/*                    </ContentSub>*/}
                {/*                    <ContentSub>*/}
                {/*                        <ContentSubTitle>맞춤형 <BrTag/> 이동</ContentSubTitle>*/}
                {/*                        <ContentSubText style={{ display: 'block' }}>*/}
                {/*                            <TextWrapper><BoldText>차홀로 집에</BoldText> - 집에 키만 맡겨두고 [ 집 > 정비소 / 정비완료 / 정비소 > 집 ] 딜리버리 서비스 이용</TextWrapper>*/}
                {/*                            <TextWrapper><BoldText>정비하고 오겠습니다</BoldText> - 업무시간동안 [ 회사 > 정비소 / 정비완료 / 정비소 > 회사 ] 딜리버리 서비스 이용</TextWrapper>*/}
                {/*                            <TextWrapper><BoldText>데리러 와줄래?</BoldText> - 혼잡한 출근시간을 피해 [집 > 정비소] 로 딜리버리 입고 후 [정비소 > 회사] 로 배송받아 여유로운 이동</TextWrapper>*/}
                {/*                            <TextWrapper><BoldText>먼저가 난 이미 틀렸어</BoldText> - 퇴근후 여유로운 한잔을 위해 [ 회사 > 정비소 ] 로 딜리버리 입고 후 [ 정비소 > 집 ] 으로 주차</TextWrapper>*/}
                {/*                            <TextWrapper><BoldText>열심히 일한 당신 떠나라</BoldText> - 회사에서 바로 여행 떠날때 짐을 미리 실어놓고 퇴근시간에 맞춰 [ 집 > 회사 ] 로 딜리버리 신청</TextWrapper>*/}
                {/*                            <TextWrapper style={{ color: '#EB3F3D' }}><BoldText></BoldText>*현재 왕복이동 서비스는 지원하지 않으며, 각 이동에 대해 개별로 접수해 주셔야 합니다.</TextWrapper>*/}
                {/*                        </ContentSubText>*/}
                {/*                    </ContentSub>*/}
                {/*                </Content1>*/}
                {/*            </div>*/}
                {/*        </GuideContent>*/}
                {/*        <GuideContent >*/}
                {/*            <FAQ src={FaqImg} onClick={() => { window.open("https://ywsoftstar-t.tistory.com/category/%EC%A0%95%EB%B9%84%ED%83%81%EC%86%A1FAQ",'window_name','width=430,height=500,location=no,status=no,scrollbars=yes'); }} />*/}
                {/*            <BlueBoldText onClick={() => {setOnPopup(false)}}>커서를 밖으로 옮기면 닫힘 <img style={{ marginLeft: '5px' }} src={ArrowUp} /></BlueBoldText>*/}
                {/*            <BlueBoldMobileText onClick={() => {setOnPopup(false)}}>클릭 <img style={{ marginLeft: '5px' }} src={ArrowUp} /></BlueBoldMobileText>*/}
                {/*        </GuideContent>*/}
                {/*    </GuideContentFrame>*/}
                {/*}*/}


                <Collapse in={onPopup} timeout="auto" unmountOnExit>
                    <GuideContentFrame>
                        <GuideContent>
                            <div>
                                <SubTitleText>공임나라 딜리버리 서비스?</SubTitleText>
                                <SubContentText>
                                    "귀찮은 내 차 정비 이동, 꼭 내가 해야 할까?" <br/>
                                    공임나라가 자동차 이동 서비스를 시작합니다.
                                    공임나라 이용시 번거롭게 내 차를 직접 가져다주고,
                                    가져올 필요가 없습니다. 정비 입고 뿐 아니라
                                    출고에 맞춰 예약만 하면 고객님의 자동차를 원하는 시간,
                                    원하는 장소까지 안전하게 옮겨 드리는 편리한 서비스입니다.
                                </SubContentText>
                            </div>
                            <div>
                                <ContentImg src={GuideImg} />
                            </div>
                        </GuideContent>
                        <GuideContent>
                            <div>
                                <SubTitleText>공ㆍ딜 200% 활용하기</SubTitleText>
                                <Content1>
                                    <ContentSub>
                                        <ContentSubTitle>보내기</ContentSubTitle>
                                        <ContentSubText>출근시 딜리버리로 정비입고 후 퇴근시 방문하여 귀가 [ 집 or 회사 > 정비소 ] </ContentSubText>
                                    </ContentSub>
                                    <ContentSub>
                                        <ContentSubTitle>가져오기</ContentSubTitle>
                                        <ContentSubText>출근시 정비소에 직접 입고 후 [ 정비소 > 집 or 회사 ] 로 딜리버리</ContentSubText>
                                    </ContentSub>
                                    <ContentSub>
                                        <ContentSubTitle>맞춤형 <BrTag/> 이동</ContentSubTitle>
                                        <ContentSubText style={{ display: 'block' }}>
                                            <TextWrapper><BoldText>차홀로 집에</BoldText> - 집에 키만 맡겨두고 [ 집 > 정비소 / 정비완료 / 정비소 > 집 ] 딜리버리 서비스 이용</TextWrapper>
                                            <TextWrapper><BoldText>정비하고 오겠습니다</BoldText> - 업무시간동안 [ 회사 > 정비소 / 정비완료 / 정비소 > 회사 ] 딜리버리 서비스 이용</TextWrapper>
                                            <TextWrapper><BoldText>데리러 와줄래?</BoldText> - 혼잡한 출근시간을 피해 [집 > 정비소] 로 딜리버리 입고 후 [정비소 > 회사] 로 배송받아 여유로운 이동</TextWrapper>
                                            <TextWrapper><BoldText>먼저가 난 이미 틀렸어</BoldText> - 퇴근후 여유로운 한잔을 위해 [ 회사 > 정비소 ] 로 딜리버리 입고 후 [ 정비소 > 집 ] 으로 주차</TextWrapper>
                                            <TextWrapper><BoldText>열심히 일한 당신 떠나라</BoldText> - 회사에서 바로 여행 떠날때 짐을 미리 실어놓고 퇴근시간에 맞춰 [ 집 > 회사 ] 로 딜리버리 신청</TextWrapper>
                                            <TextWrapper style={{ color: '#EB3F3D' }}><BoldText></BoldText>*현재 왕복이동 서비스는 지원하지 않으며, 각 이동에 대해 개별로 접수해 주셔야 합니다.</TextWrapper>
                                        </ContentSubText>
                                    </ContentSub>
                                </Content1>
                            </div>
                        </GuideContent>
                        <GuideContent >
                            <FAQ src={FaqImg} onClick={() => { window.open("https://ywsoftstar-t.tistory.com/category/%EC%A0%95%EB%B9%84%ED%83%81%EC%86%A1FAQ",'window_name','width=430,height=500,location=no,status=no,scrollbars=yes'); }} />
                            <BlueBoldText onClick={() => {setOnPopup(false)}}>닫기 <img style={{ marginLeft: '5px' }} src={ArrowUp} /></BlueBoldText>
                            <BlueBoldMobileText onClick={() => {setOnPopup(false)}}>닫기 <img style={{ marginLeft: '5px' }} src={ArrowUp} /></BlueBoldMobileText>
                        </GuideContent>
                    </GuideContentFrame>
                </Collapse>
            </GuideWrapper>
            <GuideMobile>
                <GuideMobileButton onClick={() => {setMobilePopup(true)}}>공ㆍ딜?</GuideMobileButton>
                { mobilePopup === true &&
                    <GuidePopup>
                        <PopupContent>
                            <PopupTitle>
                                공임나라 딜리버리 이용 가이드
                            </PopupTitle>
                            <PopupText>
                                <SubTitleText style={{ textAlign: 'left' }}>공임나라 딜리버리 서비스?</SubTitleText>
                                <SubContentText style={{ textAlign: 'left' }}>
                                    "귀찮은 내 차 정비 이동, 꼭 내가 해야 할까?"
                                    공임나라가 자동차 이동 서비스를 시작합니다. 공임나라 이용시 번거롭게 내 차를 직접 가져다주고, 가져올 필요가 없습니다. 정비 입고 뿐 아니라 출고에 맞춰 예약만 하면 고객님의 자동차를 원하는 시간, 원하는 장소까지 안전하게 옮겨 드리는 편리한 서비스입니다.
                                </SubContentText>
                                <ContentImg src={GuideImg} />
                                <SubTitleText style={{ textAlign: 'left' }}>공ㆍ딜 200% 활용하기</SubTitleText>
                                <BoldText>보내기</BoldText>
                                <TextWrapper style={{ textAlign: 'left' }}>출근시 딜리버리로 정비입고 후 퇴근시 방문하여 귀가 [ 집 or 회사 > 정비소 ] </TextWrapper>
                                <BoldText>가져오기</BoldText>
                                <TextWrapper style={{ textAlign: 'left' }}>출근시 정비소에 직접 입고 후 [ 정비소 > 집 or 회사 ] 로 딜리버리</TextWrapper>
                                <BoldText>맞춤형 이동</BoldText>
                                <TextWrapper style={{ textAlign: 'left' }}>차홀로 집에 - 집에 키만 맡겨두고 [ 집 > 정비소 / 정비완료 / 정비소 > 집 ] 딜리버리 서비스 이용</TextWrapper>
                                <TextWrapper style={{ textAlign: 'left' }}>정비하고 오겠습니다 - 업무시간동안 [ 회사 > 정비소 / 정비완료 / 정비소 > 회사 ] 딜리버리 서비스 이용</TextWrapper>
                                <TextWrapper style={{ textAlign: 'left' }}>데리러 와줄래? - 혼잡한 출근시간을 피해 [ 집 > 정비소 ] 로 딜리버리 입고 후 [ 정비소 > 회사 ] 로 배송받아 여유로운 이동</TextWrapper>
                                <TextWrapper style={{ textAlign: 'left' }}>먼저가 난 이미 틀렸어 - 퇴근후 여유로운 한잔을 위해 [ 회사 > 정비소 ] 로 딜리버리 입고 후 [ 정비소 > 집 ] 으로 주차</TextWrapper>
                                <TextWrapper style={{ textAlign: 'left' }}>열심히 일한 당신 떠나라 - 회사에서 바로 여행 떠날때 짐을 미리 실어놓고 퇴근시간에 맞춰 [ 집 > 회사 ] 로 딜리버리 신청</TextWrapper>
                                <TextWrapper style={{ textAlign: 'left', color: '#EB3F3D' }}>*현재 왕복이동 서비스는 지원하지 않으며, 각 이동에 대해 개별로 접수해 주셔야 합니다.</TextWrapper>
                                <FAQ onClick={() => { window.open("https://ywsoftstar-t.tistory.com/category/%EC%A0%95%EB%B9%84%ED%83%81%EC%86%A1FAQ",'window_name','width=430,height=500,location=no,status=no,scrollbars=yes'); }} src={FaqImg} ></FAQ>
                            </PopupText>
                        </PopupContent>
                        <ButtonLine style={{ padding: "0" }}>
                            <ButtonRed onClick={() => { setMobilePopup(false) }}>닫기</ButtonRed>
                        </ButtonLine>
                    </GuidePopup>
                }
            </GuideMobile>
        </>
    )
}
